<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.products" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a routerLink="..">Products</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				{{ product.name }}
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<div class="btn-group">
				<button *ngIf="canEdit" type="button" class="btn btn-outline-primary" [routerLink]="['edit']" ngbTooltip="Edit"
					placement="start">
					<fa-icon icon="pencil" size="sm"></fa-icon>
					<!-- <span class="cp-action-button-text">Edit</span> -->
				</button>

				<button *ngIf="canSendNotifications" type="button" class="btn btn-outline-primary" [routerLink]="['notify']"
					ngbTooltip="Notify" placement="bottom-end">
					<fa-icon [icon]="ac.sectionIcons.mynotifications" size="sm"></fa-icon>
				</button>

				<button *ngIf="canDelete" type="button" class="btn btn-outline-danger" (click)="prepDelete()" ngbTooltip="Delete"
					placement="start">
					<fa-icon [icon]="['fas', 'trash-alt']" size="sm"></fa-icon>
					<!-- <span class="cp-action-button-text">Delete</span> -->
				</button>
			</div>
		</div>
	</div>
</div>

<div class="tab-container">
	<ul class="cp-nav-tabs" id="myTab" role="tablist">
		<li class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab active" data-bs-toggle="tab" role="tab" aria-selected="true"
				id="nav-base-tab" aria-controls="nav-base" data-bs-target="#nav-base">
				<fa-icon [icon]="['fas', 'info-circle']" size="sm"></fa-icon>
				Info
			</button>
		</li>

		<li *ngIf="builds.length > 0" class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-builds-tab" aria-controls="nav-builds" data-bs-target="#nav-builds">
				<fa-icon [icon]="ac.sectionIcons.builds" size="sm"></fa-icon>
				Builds
				<span *ngIf="!loading || builds.length > 0" class="cp-tab-badge">
					{{ builds.length | number}}
				</span>
			</button>
		</li>

		<li *ngIf="documents.length > 0" class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-documents-tab" aria-controls="nav-documents" data-bs-target="#nav-documents">
				<fa-icon [icon]="ac.sectionIcons.documents" size="sm"></fa-icon>
				Documents
				<span *ngIf="!loading || documents.length > 0" class="cp-tab-badge">
					{{ documents.length | number}}
				</span>
			</button>
		</li>

		<li *ngIf="organizations.length > 0" class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-organizations-tab" aria-controls="nav-organizations" data-bs-target="#nav-organizations">
				<fa-icon [icon]="ac.sectionIcons.organizations" size="sm"></fa-icon>
				Organizations
				<span *ngIf="!loading || organizations.length > 0" class="cp-tab-badge">
					{{ organizations.length | number}}
				</span>
			</button>
		</li>

		<li *ngIf="packages.length > 0" class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-packages-tab" aria-controls="nav-packages" data-bs-target="#nav-packages">
				<fa-icon [icon]="ac.sectionIcons.packages" size="sm"></fa-icon>
				Packages
				<span *ngIf="!loading || packages.length > 0" class="cp-tab-badge">
					{{ packages.length | number}}
				</span>
			</button>
		</li>

		<li class="cp-nav-item" role="presentation">
			<button type="button" class="cp-nav-tab-link cp-std-tab" data-bs-toggle="tab" role="tab" aria-selected="false"
				id="nav-admin-log-tab" aria-controls="nav-admin-log" data-bs-target="#nav-admin-log">
				<fa-icon [icon]="ac.sectionIcons.adminlogs" size="sm"></fa-icon>
				<!-- Log -->
			</button>
		</li>

		<app-loading-spinner *ngIf="loading"></app-loading-spinner>
	</ul>

	<div class="tab-content" id="nav-tabContent">
		<div class="tab-pane show active" id="nav-base" role="tabpanel" aria-labelledby="nav-base-tab">
			<div *ngIf="!!product" class="cp-property-list">
				<div class="cp-property-block">
					<span class="cp-property-label">Name:</span>
					<span class="cp-property-value">{{ product.name }}</span>
				</div>

				<div class="cp-property-block">
					<span class="cp-property-label">Filename Prefix (for auto-build):</span>
					<span class="cp-property-value">{{ product.filename_prefix }}</span>
				</div>

				<div class="cp-property-block">
					<span class="cp-property-label">Type:</span>
					<span class="cp-property-value">{{ ac.productTypeLabels[product.ptype] }}</span>
				</div>

				<div class="cp-property-block" *ngIf="!!product.information && product.information !== ''">
					<span class="cp-property-label">Information:</span>
					<span class="cp-property-value cp-pre-text">{{ product.information }}</span>
				</div>

				<div class="cp-property-block" *ngIf="!!product.download_build_description && product.download_build_description !== ''">
					<span class="cp-property-label">Download List Description (Build):</span>
					<span class="cp-property-value cp-pre-text">{{ product.download_build_description }}</span>
				</div>

				<div class="cp-property-block"
					*ngIf="!!product.download_document_description && product.download_document_description !== ''">
					<span class="cp-property-label">Download List Description (Document):</span>
					<span class="cp-property-value cp-pre-text">{{ product.download_document_description }}</span>
				</div>

				<div class="cp-property-block">
					<span class="cp-property-label">Added:</span>
					<span class="cp-property-value">
						{{ product.added_on | date: ac.pageDateTimeFmt }}
						<span *ngIf="addedByUser"> by
							<a [routerLink]="['/' + ac.urls.users, addedByUser.id  ]" [ngbPopover]="userPopupContent"
								popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
								{{ addedByUser.name }}</a>
							<ng-template #userPopupContent>
								<app-card-user [object]="addedByUser"></app-card-user>
							</ng-template>
						</span>
					</span>
				</div>

				<div class="cp-property-block" *ngIf="product.added_on !== product.edited_on">
					<span class="cp-property-label">Edited:</span>
					<span class="cp-property-value">
						{{ product.edited_on | date: ac.pageDateTimeFmt }}
						<span *ngIf="editedByUser"> by
							<a [routerLink]="['/' + ac.urls.users, editedByUser.id  ]" [ngbPopover]="userPopupContent"
								popoverClass="cp-popover-std" triggers="mouseenter:mouseleave" container="body">
								{{ editedByUser.name }}</a>
							<ng-template #userPopupContent>
								<app-card-user [object]="editedByUser"></app-card-user>
							</ng-template>
						</span>
					</span>
				</div>

				<div class="cp-property-block" *ngIf="flagsToShow.length !== 0">
					<span class="cp-property-label">Special Flags:</span>
					<ul class="mb-0">
						<li *ngFor="let flagToShow of flagsToShow" class="cp-property-value">
							{{ flagToShow }}
						</li>
					</ul>
				</div>

				<div class="cp-property-block" *ngIf="platforms.length !== 0">
					<span class="cp-property-label">Platforms</span>
					<ul class="mb-0">
						<li *ngFor="let item of platforms">
							<a *ngIf="canEdit" [routerLink]="['/' + ac.urls.platforms, item.id]">
								<fa-icon [icon]="mt.getPlatformIcon(item.name)"></fa-icon>
								{{ item.name }}
							</a>
							<span *ngIf="!canEdit">
								<fa-icon [icon]="mt.getPlatformIcon(item.name)"></fa-icon>
								{{ item.name }}
							</span>
						</li>
					</ul>
				</div>
			</div>


			<button type="button" class="btn btn-outline-secondary btn-sm me-2 mb-1" (click)="openDownloadsReport()"
				placement="bottom-start" ngbTooltip="Get full record of all downloads of all build related files for this product">
				<fa-icon icon="file-excel" size="sm"></fa-icon>
				Downloads Report
			</button>

		</div>

		<div class="tab-pane show" id="nav-builds" role="tabpanel" aria-labelledby="nav-builds-tab">
			<div *ngIf="!loading && builds.length === 0" class="cp-light-message">
				No Builds for this Product.
			</div>

			<app-table-builds #buildsTable1></app-table-builds>
		</div>

		<div class="tab-pane show" id="nav-documents" role="tabpanel" aria-labelledby="nav-documents-tab">
			<div *ngIf="!loading && documents.length === 0" class="cp-light-message">
				No Documents for this Product.
			</div>

			<app-table-documents #documentsTable1></app-table-documents>

		</div>

		<div class="tab-pane show" id="nav-organizations" role="tabpanel" aria-labelledby="nav-organizations-tab">
			<div *ngIf="!loading && organizations.length === 0" class="cp-light-message">
				No Organizations with access to this Product.
			</div>

			<app-table-organizations #orgsTable1></app-table-organizations>
		</div>

		<div class="tab-pane show" id="nav-packages" role="tabpanel" aria-labelledby="nav-packages-tab">
			<div *ngIf="!loading && packages.length === 0" class="cp-light-message">
				No Packages with access to this Product.
			</div>

			<table class="cp-std-table cp-auto-width">
				<thead>
					<tr>
						<th class="cp-icon-header">
							<fa-icon [icon]="['fas', 'power-off']" size="sm" placement="end" ngbTooltip="Enabled/Disabled">
							</fa-icon>
						</th>
						<th>Name</th>
						<th>Type</th>
						<th>Platforms</th>
						<th class="cp-icon-header">
							<fa-icon [icon]="ac.sectionIcons.users" size="sm" ngbTooltip="Subscribed Users" placement="start">
							</fa-icon>
						</th>
					</tr>
				</thead>

				<tbody *ngIf="!!packages && packages.length !== 0">
					<tr *ngFor="let item of packages" [routerLink]="['/' + ac.urls.packages, item.id]" class="cp-pointer">
						<td class="cp-icon-cell text-center">
							<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
								ngbTooltip="Enabled - Downloads available" placement="end">
							</fa-icon>
							<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
								ngbTooltip="Disabled - Downloads not available" placement="end"></fa-icon>
						</td>
						<td class="cp-chopped-col-long">
							<a [routerLink]="['/' + ac.urls.packages, item.id]">{{ item.name }}</a>
						</td>
						<td class="cp-chopped-col-medium">{{ ac.packageTypeLabels[item.ptype] }}</td>
						<td>
							<span *ngFor="let pl of mt.sortPlatforms(platforms, getPlatformIdsForProduct(id, item.product_platforms))">
								<fa-icon [icon]="mt.getPlatformIcon(pl.name)"></fa-icon>
								{{ pl.name }}&nbsp;
							</span>
						</td>
						<td class="text-center">{{ item.num_users | number }}</td>
					</tr>
				</tbody>

			</table>
		</div>

		<div class="tab-pane" id="nav-admin-log" role="tabpanel" aria-labelledby="nav-admin-log-tab">

			<div *ngIf="!loading && (!!product && adminLogs.length === 0)" class="cp-light-message">
				No system/change Logs for this Product.
			</div>

			<app-table-logs #logsTable1 [expandNames]="true"></app-table-logs>
		</div>


	</div>
</div>

<app-popup-box [parentApi]="getParentMethod()"></app-popup-box>